var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import Loading from 'components/shared/Loading';
import Error from 'components/shared/Error';
import MainBox from './MainBox';
import Products from './Products';
import MobileProducts from './Products/MobileProducts';
import Notices from './Notices';
import Contacts from './Contacts';
import { isDev } from 'shared/logic';
var GET_HOME = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetHome($projectName: String!, $boardId: String!, $limit: Int!) {\n    project(projectName: $projectName) {\n      id\n      home {\n        main {\n          bgUrl\n          title\n          content\n        }\n        products {\n          bgUrl\n          name\n          link\n        }\n      }\n      contacts {\n        name\n        value\n        callable\n      }\n      address {\n        text\n        lat\n        lng\n      }\n    }\n    notices: latestPosts(boardId: $boardId, limit: $limit) {\n      createdAt\n      title\n      numberInBoard\n      parent {\n        urlName\n      }\n    }\n  }\n"], ["\n  query GetHome($projectName: String!, $boardId: String!, $limit: Int!) {\n    project(projectName: $projectName) {\n      id\n      home {\n        main {\n          bgUrl\n          title\n          content\n        }\n        products {\n          bgUrl\n          name\n          link\n        }\n      }\n      contacts {\n        name\n        value\n        callable\n      }\n      address {\n        text\n        lat\n        lng\n      }\n    }\n    notices: latestPosts(boardId: $boardId, limit: $limit) {\n      createdAt\n      title\n      numberInBoard\n      parent {\n        urlName\n      }\n    }\n  }\n"])));
var Home = /** @class */ (function (_super) {
    __extends(Home, _super);
    function Home() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Home.prototype.render = function () {
        var project = this.props.project;
        var boardId = isDev
            ? {
                'mohyun': '9b2d9adb-5f8f-4b25-b8ea-b7c086b4600a',
                'bmntech': '9b2d9adb-5f8f-4b25-b8ea-b7c086b4600a'
            }
            : {
                'mohyun': '9b2d9adb-5f8f-4b25-b8ea-b7c086b4600a',
                'bmntech': 'dd308af7-ae93-4d96-b29b-88a36042aada'
            };
        return (React.createElement(Query, { query: GET_HOME, variables: {
                projectName: project,
                boardId: boardId[project],
                limit: 4,
            } }, function (_a) {
            var loading = _a.loading, error = _a.error, data = _a.data;
            if (loading)
                return React.createElement(Loading, null);
            if (error)
                return React.createElement(Error, null);
            var notices = data.notices, _b = data.project, home = _b.home, contacts = _b.contacts, address = _b.address;
            return (React.createElement(React.Fragment, null,
                React.createElement(MainBox, { mainbox: home.main }),
                React.createElement(Products, { products: home.products }),
                React.createElement(MobileProducts, { products: home.products }),
                React.createElement(Notices, { notices: notices, project: project }),
                React.createElement(Contacts, { contacts: contacts, address: address, project: project })));
        }));
    };
    return Home;
}(React.Component));
export default Home;
var templateObject_1;
